// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"689f94e1","285":"7a812936","787":"e25faedd","858":"e7f92134"}[chunkId] + ".chunk.js";
};